import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PoliticaTratamientoService {
  private apiUrlPersona = `${environment.apiUrl}/datoadicionalpersona/aceptardatos`;
  private apiUrlAbogado = `${environment.apiUrl}/datoadicionalpersona/aceptardatos`;

  constructor(private http: HttpClient) {}

  aceptaPoliticaPersona(idUsuario: number): Observable<{ exitoso: boolean }> {
    return this.http.get<{ exitoso: boolean }>(
      `${this.apiUrlPersona}/${idUsuario}`
    );
  }
  aceptaPoliticaAbogado(idUsuario: number): Observable<{ exitoso: boolean }> {
    return this.http.get<{ exitoso: boolean }>(
      `${this.apiUrlAbogado}/${idUsuario}`
    );
  }
}
